import { render } from "./ow-appointments-form.vue?vue&type=template&id=4662943c&scoped=true"
import script from "./ow-appointments-form.vue?vue&type=script&lang=js"
export * from "./ow-appointments-form.vue?vue&type=script&lang=js"

import "./ow-appointments-form.vue?vue&type=style&index=0&id=4662943c&lang=scss"
import "./ow-appointments-form.vue?vue&type=style&index=1&id=4662943c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4662943c"]])

export default __exports__